<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-overlay
        :show="__isOnLoad"
        variant="white"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >

      <div class="inscription-form">
        <div class="form-section">
          <div class="form-section-title">Informations société</div>
          <div class="row">
            <div class="col-md-12">
              <label class="form-label">Société <span class="required">*</span></label>
              <base-input
                placeholder="Nom de la société"
                v-model="__item.name"
                :isMnadatory = true
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>

            <div class="col-md-6">
              <label class="form-label">Téléphone <span class="required">*</span></label>
              <base-input
                placeholder="Téléphone"
                v-model="__item.tel"
                :isMnadatory = true
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>

            <div class="col-md-6">
              <label class="form-label">Fax</label>
              <base-input
                placeholder="Fax"
                v-model="__item.fax"
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>

            <div class="col-md-6">
              <label class="form-label">Email <span class="required">*</span></label>
              <base-input
                placeholder="Email"
                v-model="__item.email"
                :isMnadatory = true
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
              <small v-if="emailVerificationVerified" class="verification-state verification-state-success">Adresse confirmée</small>
            </div>

            <div v-if="emailVerificationRequested" class="col-md-3">
              <label class="form-label">Code e-mail <span class="required">*</span></label>
              <base-input
                placeholder="6 chiffres"
                :value="emailVerificationCode"
                maxlength="6"
                inputmode="numeric"
                autocomplete="one-time-code"
                @input="$emit('update-email-verification-code', $event.replace(/\D/g, '').slice(0, 6))"
                type="string"
                :error="errorCtrl"
              ></base-input>
              <small class="verification-state">Valable encore {{ formattedVerificationRemaining }}</small>
            </div>

            <div :class="emailVerificationRequested ? 'col-md-3 verification-action' : 'col-md-6 verification-action'">
              <label class="form-label">Vérification e-mail</label>
              <b-button
                block
                size="sm"
                variant="outline-primary"
                :disabled="emailVerificationBusy || emailVerificationVerified"
                @click="$emit('request-email-verification')"
              >
                {{ emailVerificationRequested ? 'Renvoyer' : 'Envoyer le code' }}
              </b-button>
              <b-button
                v-if="emailVerificationRequested"
                block
                size="sm"
                variant="primary"
                :disabled="emailVerificationBusy || emailVerificationCode.length !== 6"
                @click="$emit('confirm-email-verification')"
              >
                Confirmer
              </b-button>
            </div>
          </div>
        </div>

        <div class="form-section">
          <div class="form-section-title">Informations fiscales</div>
          <div class="row">
            <div class="col-md-6">
              <label class="form-label">Matricule Fiscal</label>
              <base-input
                placeholder="Matricule Fiscal"
                v-model="__item.mf"
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>

            <div class="col-md-6">
              <label class="form-label">N° registre de commerce</label>
              <base-input
                placeholder="NRC"
                v-model="__item.nrc"
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>
          </div>
        </div>

        <div class="form-section">
          <div class="form-section-title">Localisation</div>
          <div class="row">
            <div class="col-md-4">
              <label class="form-label">Ville</label>
              <selector _id="67786b6ee4f5b22e0ae23681" :_parentItem="__item" _warpper="ville" :_showTitle="false" _customCss=" border-radius: 10px; float: left"></selector>
            </div>
            <div class="col-md-8">
              <label class="form-label">Adresse</label>
              <base-input
                placeholder="Adresse"
                v-model="__item.adress"
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>
          </div>
        </div>

        <div class="form-section form-section-accent">
          <div class="form-section-title">Accès à votre compte</div>
          <p class="form-section-note">Afin de pouvoir accéder à votre compte ITTEC et suivre vos demandes</p>
          <div class="row">
            <div class="col-md-6">
              <label class="form-label">Login <span class="required">*</span></label>
              <base-input
                placeholder="Login"
                v-model="__item.login"
                :isMnadatory = true
                type = "string"
                :error = "errorCtrl"
              >
              </base-input>
            </div>

            <div class="col-md-6">
              <label class="form-label">Mot de passe <span class="required">*</span></label>
                <base-input
                  placeholder="Mot de passe"
                  v-model="__item.pwd"
                  type = "password"
                :isMnadatory = true
                :error = "errorCtrl"
              >
              </base-input>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <b-button 
            variant="primary" 
            size="lg" 
            block 
            @click="dispatchSave()" 
            v-if="(errorCtrl.filter(e => e.isValid === false).length === 0)"
            class="btn-inscription"
          >
            <b-icon icon="check-circle" class="mr-2"></b-icon>
            Valider l'inscription
          </b-button>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>


export default {
  components: {

  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    emailVerificationRequested: {
      type: Boolean,
      default: false,
    },
    emailVerificationVerified: {
      type: Boolean,
      default: false,
    },
    emailVerificationCode: {
      type: String,
      default: '',
    },
    emailVerificationRemaining: {
      type: Number,
      default: 0,
    },
    emailVerificationBusy: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      fullList: [],
      errorCtrl: [],
    }
  },
  computed: {
    formattedVerificationRemaining() {
      const minutes = Math.floor(this.emailVerificationRemaining / 60);
      const seconds = String(this.emailVerificationRemaining % 60).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
  },
  methods: {

    dispatchSave() {
      this.$parent.copieAction();
    },

  },
  mounted() {
  },

  watch: {
    
  },


};
</script>
<style scoped>
.inscription-form {
  width: 100%;
}

.form-section {
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
}

.form-section-accent {
  background: #fef9f3;
  margin-left: -40px;
  margin-right: -40px;
  padding: 20px 40px;
  border-bottom: none;
  border-radius: 8px;
}

.form-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e1e2f;
  margin-bottom: 15px;
}

.form-section-note {
  font-size: 13px;
  color: #888;
  font-style: italic;
  margin-bottom: 15px;
}

.form-label {
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 4px;
  display: block;
}

.required {
  color: #f1851b;
}

.verification-action .btn + .btn {
  margin-top: 8px;
}

.verification-state {
  display: block;
  margin-top: 5px;
  font-size: 12px;
  color: #6b7280;
}

.verification-state-success {
  color: #198754;
  font-weight: 600;
}

.form-actions {
  margin-top: 20px;
  text-align: center;
}

.btn-inscription {
  background: #f1851b;
  border-color: #f1851b;
  font-weight: 600;
  padding: 12px 30px;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s;
}
.btn-inscription:hover {
  background: #d9741a;
  border-color: #d9741a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(241,133,27,0.35);
}

@media (max-width: 768px) {
  .col-md-6,
  .col-md-4,
  .col-md-8 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .form-section-accent {
    margin-left: -16px;
    margin-right: -16px;
    padding: 16px;
  }
}
</style>
<style>
.modal-xl {
  max-width: 85% !important;
}
.editionPanel {
    width: 100%;
    padding: 2%;
    margin-bottom: 10px;
    border-radius: 10px;
    background-color: #fff;
}
.form-control option {
  color: black;
}
</style>
